import { Observable } from 'rxjs';

export interface Payee {
  p_name: string,
  p_office: string,
  p_address: string
}

export interface PayeeList {
  p_name: string,
  p_office: string,
  p_address: string,
  p_tin: string
}

export interface ApiResponse {
  code: number,
  message: any
}

export abstract class PayeeData {
  abstract get(form: Payee): Observable<ApiResponse>;
}
